import { ProductImageFormat } from '../constants/index.js';
import { replaceWithJioCDN } from './imageHandling';

// update this function with priority of image type
export function getImageUrlFromProductImages(
  images,
  type = ProductImageFormat.PRODUCT,
  priority = [
    // verify this list
    ProductImageFormat.PRODUCT,
    ProductImageFormat.CART_ICON,
    ProductImageFormat.MOBILE_PRODUCT_LISTING_IMAGE,
    ProductImageFormat.THUMNAIL
  ]
) {
  let returnURL = '';
  returnURL = images.reduce((imageUrl, item) => {
    if (item.format == 'cartIcon') {
      imageUrl = `${item.url}`;
    } else if (item.format == 'mobileProductListingImage') {
      imageUrl = `${item.url}`;
    } else if (item.format == 'PRIMARY') {
      imageUrl = `${item.url}`;
    }
    return replaceWithJioCDN(imageUrl);
  }, '');

  return returnURL;
}

export function getImageAltTextFromProductImages(images) {
  let returnAltTxt = '';
  returnAltTxt = images.reduce((imgAlt, item) => {
    let imageAltTxt = imgAlt;
    if (item.format == 'cartIcon') {
      imageAltTxt = `${item.altText}`;
    } else if (item.format == 'mobileProductListingImage') {
      imageAltTxt = `${item.altText}`;
    } else if (item.format == 'PRIMARY') {
      imageAltTxt = `${item.altText}`;
    }
    return imageAltTxt;
  }, '');

  return returnAltTxt;
}

export function getPriceErrorPdp(serviceErrors = []) {
  const codeArr = [];
  serviceErrors.forEach(err => {
    const { code } = err;
    const codeVal = code ? code.toString().slice(0, 3) : '';
    codeArr.push(codeVal);
  });
  return codeArr.includes('902');
}

export function getTagValueFromTagEngine(categoryTags = []) {
  const filterProductTag =
    categoryTags.length > 0 ? categoryTags.filter(data => data.category == 'SELLING_POINT')[0] : {};
  return filterProductTag?.primary?.value || filterProductTag?.value || '';
}

export function getPLPTagV2FromPosition(positions = [], positionKey) {
  const filterProductTag = positions.find(data => data.position === positionKey);
  return filterProductTag?.tag?.[0] || {};
}

export function getPDPTagV2FromPosition(productTag = {}, positionKey) {
  const { positions = [] } = productTag;
  const filterProductTag = positions.find(data => data.position === positionKey);
  return filterProductTag?.tag?.[0] || {};
}

export function getPriceLableFromTagEngine(categoryTags = []) {
  const filterLabel =
    categoryTags.length > 0 ? categoryTags.filter(data => data.category == 'BARGAIN')[0] : {};
  return filterLabel?.primary?.value || '';
}

export function getSellingFastTagFromTagEngine(categoryTags = []) {
  const filterLabel =
    categoryTags.length > 0 ? categoryTags.filter(data => data.category === 'URGENCY')[0] : {};
  return filterLabel?.primary?.value || '';
}

export function getSellingFastLableFromTagEngine(productDetails) {
  const { tagResponse: { tag: { categoryTags = [] } = {} } = {} } = productDetails;
  const filterLabel =
    categoryTags.length > 0 ? categoryTags.filter(data => data.category === 'URGENCY')[0] : {};
  return filterLabel?.primary?.value || '';
}

export function getSimilarProductsWithLimit(similarProducts = [], similarDataMaxLimit = 0) {
  const similarProductsLength = similarProducts?.length || 0;
  if (similarProductsLength > 0) {
    const similarDataList = similarProducts;
    if (similarDataMaxLimit > 0 && similarDataMaxLimit < similarProductsLength) {
      const newSimilarDataList = similarDataList.slice(0, similarDataMaxLimit);
      return newSimilarDataList;
    }
    if (similarDataMaxLimit > 0 && similarDataMaxLimit > similarProductsLength) {
      return similarProducts;
    }
  } else {
    return similarProducts;
  }
}
